import * as React from 'react'

function IconRhombusBlocked({
  isFill,
  props,
}: {
  isFill: boolean
  props?: React.SVGProps<SVGSVGElement>
}) {
  return (
    <svg
      width={104}
      height={103}
      viewBox="0 0 104 103"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isFill ? (
        <>
          <g filter="url(#prefix__filter0_rhombus)">
            <path
              d="M44.978 102.831L0 58.357a9.74 9.74 0 000-13.886L44.978 0c3.879 3.836 10.169 3.836 14.044 0L104 44.47a9.74 9.74 0 000 13.887l-44.974 44.474c-3.88-3.835-10.169-3.835-14.048 0z"
              fill="#A2A2A2"
            />
            <path
              d="M8.18 57.497a16.737 16.737 0 001.133-6.081c0-2.115-.39-4.17-1.133-6.081l37.487-37.74a16.431 16.431 0 006.04 1.142c2.102 0 4.142-.392 6.041-1.141l37.488 37.739a16.737 16.737 0 00-1.134 6.08c0 2.116.39 4.17 1.134 6.082L57.748 95.236a16.431 16.431 0 00-6.04-1.141c-2.101 0-4.142.392-6.04 1.141L8.18 57.496z"
              fill="#A2A2A2"
              stroke="#fff"
              strokeMiterlimit={10}
              strokeLinecap="round"
            />
            <path
              d="M40.899 39.73L63.1 62.65M63.101 39.73L40.9 62.65"
              stroke="#fff"
              strokeWidth={6}
              strokeMiterlimit={10}
              strokeLinecap="round"
            />
          </g>
          <defs>
            <filter
              id="prefix__filter0_rhombus"
              x={0}
              y={0}
              width={104}
              height={102.831}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation={5} />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2={-1}
                k3={1}
              />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
              <feBlend in2="shape" result="effect1_innerShadow" />
            </filter>
          </defs>
        </>
      ) : (
        <>
          <path
            d="M45.248 100.876L2 58.113A9.365 9.365 0 002 44.76L45.248 2c3.73 3.688 9.778 3.688 13.504 0L102 44.76a9.365 9.365 0 000 13.353l-43.244 42.763c-3.73-3.688-9.778-3.688-13.508 0z"
            fill="#fff"
            stroke="#A2A2A2"
            strokeWidth={2}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
          <path
            d="M9.865 57.285a16.094 16.094 0 001.09-5.847c0-2.034-.374-4.009-1.09-5.847L45.911 9.303a15.8 15.8 0 005.808 1.098 15.8 15.8 0 005.808-1.098l36.046 36.288a16.094 16.094 0 00-1.09 5.847c0 2.034.375 4.01 1.09 5.847L57.527 93.573a15.8 15.8 0 00-5.808-1.097 15.8 15.8 0 00-5.808 1.097L9.865 57.286z"
            fill="#A2A2A2"
            stroke="#fff"
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
          <path
            d="M41.326 40.202L62.674 62.24M62.674 40.202L41.326 62.24"
            stroke="#fff"
            strokeWidth={6}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
        </>
      )}
    </svg>
  )
}

export default IconRhombusBlocked
